module.exports = __webpack_public_path__ + "static/media/counter-icon.7c4f452d.svg";